var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.75 15.625v68.75a9.375 9.375 0 0 1-9.375 9.375h-68.75a9.375 9.375 0 0 1-9.375-9.375v-68.75a9.375 9.375 0 0 1 9.375-9.375h68.75a9.375 9.375 0 0 1 9.375 9.375zM76.562 18.75H54.694c-4.163 0-6.265 5.051-3.314 8.002L57.625 33 19.437 71.188a2.344 2.344 0 0 0 0 3.315l6.06 6.06c.915.916 2.4.916 3.315 0L67 42.375l6.248 6.248c2.935 2.935 8.002.874 8.002-3.315v-21.87a4.687 4.687 0 0 0-4.688-4.688z",
    id: "dodeoa36za"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRight);
export default __webpack_public_path__ + "static/media/arrow-up-right.b0e95e7e27152598542bdbf72af69179.svg";
export { ForwardRef as ReactComponent };